import { PostApiCall } from "./axiosSetup";

export const SIGN_IN = "/authorization/signin";
export const SIGN_UP = "/authorization/signup";
export const SIGN_OUT = "/authorization/signout";
export const RESET_PASSWORD = "/authorization/reset-password";
export const CHANGE_PASSWORD = "/authorization/change-password";

export const SignIn = async (data) => PostApiCall(SIGN_IN, data);
export const SignUp = async (data) => PostApiCall(SIGN_UP, data);
export const SignOut = async (data) => PostApiCall(SIGN_OUT, data);
export const ResetPassword = async (data) => PostApiCall(RESET_PASSWORD, data);
export const ChnagePassword = async (data) => PostApiCall(CHANGE_PASSWORD, data);
